import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/headerrh'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import HomeLogged from '../../../components/rh/home'

function HomeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="RH - Administrador" />
                <HeaderLogged />
                <Container>
                   <HomeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default HomeLoggedScreen;